/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ID } from '@/data/types/Basic';

export const childContentManifestCustom: {
	[key: string]: ID[];
} = {};
